export const environment = {
    production: false,
    projectName: 'ADCA',
    domain:'https://adcauatcrm.crm15.dynamics.com',
    // domain: 'https://adcapreprodcrm.crm15.dynamics.com',
    // domain: 'https://adcacrm.crm15.dynamics.com',
    appId:'bee87bee-2536-ee11-bdf4-0022489fd0dc',
    appIdEservicesAndCaseManagement:'c3df4a47-5e33-ee11-bdf5-0022489fd233',
    clientId: '9f9fa6fa-0a52-447b-a769-30a45db8a2e6',
    authority: 'https://login.microsoftonline.com/76c24ade-0edf-4364-8227-a67993cb7ec4',
    configUrls: {
      email: `https://adcapreprodcrm.crm4.dynamics.com/main.aspx?appid=bee87bee-2536-ee11-bdf4-0022489fd0dc&pagetype=entityrecord&etn=msdynmkt_email&id=f924a582-4842-ee11-bdf3-0022489fd0dc`,
      text: `https://adcapreprodcrm.crm4.dynamics.com/main.aspx?appid=bee87bee-2536-ee11-bdf4-0022489fd0dc&pagetype=entityrecord&etn=msdynmkt_sms&id=dfc3d3bc-9d41-ee11-bdf3-0022489cdf05`
    }
  };
  